import React from 'react';
import RichText from '../../';
import { StyledRichTextContainer } from '../../StyledRichText/styles';

const TocRichText = ({ content, toc, ...otherProps }) => {
  let tocIndex = 0;

  if (!content) {
    return <></>;
  }

  const richContent = JSON.parse(content?.raw);
  const article = richContent?.map((document, index) => {
    if (document.content[0].nodeType === 'heading-2') {
      return (
        <div
          id={toc?.[tocIndex++]?.anchor?.split('#')?.[1]}
          className="anchor-container"
          key={index}
        >
          <RichText content={{ ...content, raw: JSON.stringify(document) }} />
        </div>
      );
    }

    return <RichText content={{ ...content, raw: JSON.stringify(document) }} key={index} />;
  });

  return <StyledRichTextContainer {...otherProps}>{article}</StyledRichTextContainer>;
};

export default TocRichText;
